export const INTRO_LIKERT_QUESTION = "Als ik iets nieuws moet doen, vind ik dat spannend.";

export const INTRO_SCENARIO = {
  situation:
    "Je broer of zus pakt iets van jou zonder te vragen. Je merkt dat je boos wordt.",
  prompt: "Wat lijkt het meest op wat jij dan doet?",
  options: [
    "Ik word meteen heel boos en ga schreeuwen.",
    "Ik zeg niets, maar blijf er boos over.",
    "Ik zeg dat ik het niet oké vind, maar blijf daarna nog lang boos in mijn hoofd.",
    "Ik merk dat ik boos word en probeer rustig te zeggen wat ik ervan vind.",
    "Ik merk de boosheid, laat die er zijn en zeg rustig wat er aan de hand is.",
  ],
} as const;
